import { toast, ToastOptions } from "react-toastify";

type ToastType = "success" | "error" | "info" | "warn";

const getToastOptions = (type: ToastType): ToastOptions => ({
  className: `app-toast app-toast--${type}`,
  bodyClassName: "app-toast__body",
  progressClassName: "app-toast__progress",
  icon: false,
});

const showToast = (message: string, type: ToastType) => {
  toast[type](message, getToastOptions(type));
};

export default showToast;
